export function normalizeRoute(route: string): string {
	return route.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
}

export function matchesRoute(pattern: string, route: string): boolean {
	const expected = pattern.split('/');
	const actual = route.split('/');
	return expected.length === actual.length && expected.every((part, index) => (part.startsWith(':') ? Boolean(actual[index]) : part === actual[index]));
}
